import classNames from 'classnames';
import { ReactComponent as UploadIcon } from '../img/iconDownload2.svg';
import { FC } from 'react';
import { useGetTemplateSetVolumeMutation } from '../../../redux/Api/ordersApi/ordersApi';
import { getFileNameFromContentDisposition } from '../../../utils/strActions';
import styles from './TemplateLink.module.scss';

interface TemplateLinkProps {
  hasFile: boolean;
}

export const TemplateLink: FC<TemplateLinkProps> = ({ hasFile }) => {
  const [getTemplateSetVolume] = useGetTemplateSetVolumeMutation();

  const handleDownloadTemplate = async () => {
    try {
      const result = await getTemplateSetVolume();

      if ('data' in result && result.data) {
        const { blob, headers } = result.data;
        const disposition = headers.get('content-disposition');
        const filename =
          getFileNameFromContentDisposition(disposition) || 'orders-set-volume.xlsx';

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Ошибка получения шаблона');
      }
    } catch (error) {
      console.error('Ошибка скачивания шаблона:', error);
    }
  };

  return (
    <button
      className={classNames(styles.link, styles.template)}
      style={!hasFile ? { marginBottom: '4px' } : {}}
      onClick={handleDownloadTemplate}
      type='button'>
      <div className={styles.textButton}>
        Отчет <UploadIcon style={{ width: '20px', height: '20px' }} />
      </div>
    </button>
  );
};
